/**
 * Application configuration
 * Supports both legacy (/api/) and versioned (/api/v1/) endpoints
 */
import logger from './logger';

const getApiUrl = () => {
  // In production builds, use relative URLs (same domain)
  // In development, use the environment variable
  if (process.env.NODE_ENV === 'production') {
    return '';  // Relative URL - API calls will go to same domain
  }
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const API_URL = getApiUrl();

// API version prefix - use v1 endpoints for all new API calls
export const API_VERSION = '/api/v1';

// Helper to build versioned API URLs
export const apiUrl = (endpoint) => {
  // Remove leading slash if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_URL}${API_VERSION}/${cleanEndpoint}`;
};

// Helper for legacy endpoints (will show deprecation warning in development)
export const legacyApiUrl = (endpoint) => {
  if (process.env.NODE_ENV === 'development') {
    logger.warn(`[DEPRECATED] Legacy API endpoint used: /api/${endpoint}. Consider migrating to /api/v1/${endpoint}`);
  }
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_URL}/api/${cleanEndpoint}`;
};

// External booking URL for "Book a Demo" CTAs
export const BOOK_DEMO_URL = 'https://calendar.app.google/wLswoEWwh4hEzkmF9';

// Helper to open booking link in a new tab
export const openBookDemo = () => {
  window.open(BOOK_DEMO_URL, '_blank', 'noopener,noreferrer');
};

export default API_URL;
